const getSvgString = (width, height, pinColors)=>`<svg width="${width}" height="${height}" viewBox="0 0 56 60" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse opacity="0.4" cx="28.5" cy="54.8625" rx="7.65" ry="1.425" fill="#2B2E31"/><g filter="url(#filter0_dd_655_11904)"><path d="M46.7001 21.85C46.7001 31.233 34.2926 46.5499 29.8235 51.4249C29.2917 52.005 28.4084 52.005 27.8765 51.4249C23.4075 46.5499 11 31.233 11 21.85C11 11.65 18.9917 4 28.85 4C38.7083 4 46.7001 11.65 46.7001 21.85Z" fill="${pinColors.background}"/><path d="M30.5607 52.1007C32.824 49.6318 37.0789 44.5407 40.7752 38.8743C42.6238 36.0406 44.3457 33.0431 45.6084 30.1432C46.865 27.2575 47.7001 24.3943 47.7001 21.85C47.7001 11.0852 39.248 3 28.85 3C18.452 3 10 11.0852 10 21.85C10 24.3943 10.8351 27.2575 12.0917 30.1432C13.3544 33.0431 15.0763 36.0406 16.9248 38.8743C20.6212 44.5407 24.8761 49.6318 27.1394 52.1007C28.0676 53.1131 29.6325 53.1131 30.5607 52.1007Z" stroke="${pinColors.foreground}" stroke-width="2"/></g><g clip-path="url(#clip0_655_11904)"><path d="M37.4257 16.3226C35.1379 14.3729 31.7354 14.7236 29.6355 16.8904L28.813 17.7378L27.9906 16.8904C25.8948 14.7236 22.4882 14.3729 20.2004 16.3226C17.5786 18.5603 17.4408 22.5765 19.7871 25.002L27.8654 33.3433C28.3872 33.8818 29.2347 33.8818 29.7565 33.3433L37.8348 25.002C40.1852 22.5765 40.0475 18.5603 37.4257 16.3226Z" fill="${pinColors.foreground}"/></g><defs><filter id="filter0_dd_655_11904" x="5" y="0" width="47.7001" height="59.8601" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_655_11904"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/><feBlend mode="normal" in2="effect1_dropShadow_655_11904" result="effect2_dropShadow_655_11904"/><feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_655_11904" result="shape"/></filter><clipPath id="clip0_655_11904"><rect width="21.375" height="21.375" fill="${pinColors.background}" transform="translate(18.125 13.9749)"/></clipPath></defs></svg>`
;
const fallbackThemes = {
    primary: {
        foreground: '#ffffff',
        background: '#1e7be2'
    },
    highlight: {
        foreground: '#ffffff',
        background: '#1862b5'
    },
    hovered: {
        foreground: '#1e7be2',
        background: '#ffffff'
    }
};
const defaultOptions = {
    width: 40,
    height: 47,
    themes: fallbackThemes
};
const PreferredStorePin = (options = defaultOptions)=>({ hovered , highlight  })=>{
        var _width;
        const width = (_width = options.width) !== null && _width !== void 0 ? _width : defaultOptions.width;
        var _height;
        const height = (_height = options.height) !== null && _height !== void 0 ? _height : defaultOptions.height;
        var _themes;
        const themes = (_themes = options.themes) !== null && _themes !== void 0 ? _themes : defaultOptions.themes;
        const anchor = {
            x: Math.round(width / 2),
            y: height
        };
        const size = {
            width,
            height
        };
        const theme = (()=>{
            if (hovered) {
                return themes.hovered;
            }
            if (highlight) {
                return themes.highlight;
            }
            return themes.primary;
        })();
        const svgString = getSvgString(width, height, theme);
        return {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
            anchor,
            size,
            scaledSize: size
        };
    }
;

export { PreferredStorePin as default, getSvgString };
//# sourceMappingURL=PreferredStorePin.js.map
